var _rect, _mask, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCrown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 27,
    fill: "#none"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2994_1262",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3004 11.5684C30.0255 11.3553 29.6916 11.2182 29.3369 11.1729C28.9821 11.1275 28.6207 11.1756 28.294 11.3118L22.2148 13.8219L18.6826 7.90917C18.5138 7.63312 18.2691 7.40355 17.9737 7.24385C17.6782 7.08414 17.3424 7 17.0006 7C16.6587 7 16.3229 7.08414 16.0275 7.24385C15.732 7.40355 15.4874 7.63312 15.3186 7.90917L11.7864 13.8219L5.70711 11.3118C5.37972 11.1758 5.01791 11.1276 4.66256 11.1726C4.30722 11.2176 3.97252 11.354 3.69629 11.5664C3.42006 11.7788 3.21333 12.0587 3.09946 12.3745C2.9856 12.6903 2.96914 13.0294 3.05194 13.3534L6.10358 25.4355C6.16193 25.6694 6.27082 25.8899 6.42364 26.0836C6.57646 26.2772 6.77004 26.4401 6.99264 26.5623C7.29401 26.7298 7.63859 26.8184 7.98983 26.8189C8.16057 26.8186 8.33043 26.796 8.49443 26.7519C14.0568 25.3239 19.9323 25.3239 25.4947 26.7519C26.0026 26.8759 26.5427 26.8077 26.9965 26.5623C27.2205 26.4417 27.4151 26.2793 27.5681 26.0853C27.7211 25.8914 27.8292 25.6701 27.8855 25.4355L30.9492 13.3534C31.0311 13.0293 31.0137 12.6904 30.8991 12.3749C30.7844 12.0595 30.5771 11.7801 30.3004 11.5684V11.5684Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3004 11.5684C30.0255 11.3553 29.6916 11.2182 29.3369 11.1729C28.9821 11.1275 28.6207 11.1756 28.294 11.3118L22.2148 13.8219L18.6826 7.90917C18.5138 7.63312 18.2691 7.40355 17.9737 7.24385C17.6782 7.08414 17.3424 7 17.0006 7C16.6587 7 16.3229 7.08414 16.0275 7.24385C15.732 7.40355 15.4874 7.63312 15.3186 7.90917L11.7864 13.8219L5.70711 11.3118C5.37972 11.1758 5.01791 11.1276 4.66256 11.1726C4.30722 11.2176 3.97252 11.354 3.69629 11.5664C3.42006 11.7788 3.21333 12.0587 3.09946 12.3745C2.9856 12.6903 2.96914 13.0294 3.05194 13.3534L6.10358 25.4355C6.16193 25.6694 6.27082 25.8899 6.42364 26.0836C6.57646 26.2772 6.77004 26.4401 6.99264 26.5623C7.29401 26.7298 7.63859 26.8184 7.98983 26.8189C8.16057 26.8186 8.33043 26.796 8.49443 26.7519C14.0568 25.3239 19.9323 25.3239 25.4947 26.7519C26.0026 26.8759 26.5427 26.8077 26.9965 26.5623C27.2205 26.4417 27.4151 26.2793 27.5681 26.0853C27.7211 25.8914 27.8292 25.6701 27.8855 25.4355L30.9492 13.3534C31.0311 13.0293 31.0137 12.6904 30.8991 12.3749C30.7844 12.0595 30.5771 11.7801 30.3004 11.5684V11.5684Z",
    fill: "#BD2333",
    stroke: "#BD2333",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_2994_1262)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 4,
    r: 3.5,
    fill: "#BD2333",
    stroke: "#BD2333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 2.5,
    fill: "white",
    stroke: "#BD2333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 10.5,
    r: 2,
    fill: "#BD2333",
    stroke: "#BD2333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 10.5,
    r: 2,
    fill: "#BD2333",
    stroke: "#BD2333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 19.5,
    r: 1,
    fill: "white",
    stroke: "#BD2333"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 19.5,
    r: 1,
    fill: "white",
    stroke: "#BD2333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrown);
export default __webpack_public_path__ + "static/media/iconCrown.337c1c4aea5d45892999515b82f05a1b.svg";
export { ForwardRef as ReactComponent };